import { Typography } from 'antd';
import { FC } from 'react';

const { Text } = Typography;

export interface RankingItem {
  id: string;
  name: string;
  count: number;
}

interface IssueRankingListProps {
  title: string;
  items: RankingItem[];
  emptyText?: string;
}

const IssueRankingList: FC<IssueRankingListProps> = ({ title, items, emptyText = '데이터 없음' }) => {
  return (
    <div>
      <Text strong style={{ fontSize: 13, color: '#666', marginBottom: 8, display: 'block' }}>
        {title}
      </Text>
      {items.length === 0 ? (
        <Text type='secondary' style={{ fontSize: 12 }}>
          {emptyText}
        </Text>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          {items.map((item, index) => (
            <div
              key={item.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                padding: '4px 8px',
                backgroundColor: '#fafafa',
                borderRadius: 4,
              }}>
              <Text style={{ fontSize: 12, color: '#999', flexShrink: 0 }}>{index + 1}.</Text>
              <Text ellipsis={{ tooltip: item.name }} style={{ flex: 1, fontSize: 12, minWidth: 0 }}>
                {item.name}
              </Text>
              <Text style={{ fontSize: 12, color: '#666', flexShrink: 0 }}>{item.count}건</Text>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default IssueRankingList;
